<template>
    <div class="meta--nav">
        <nav>
            <ul v-if="isClient">
                <li><a href="tel:+4922739537362">
                    <svg-vue icon="support-headphones" class="icon"/>
                    <translate>+ 49 (0) 2273 95 373 62</translate> </a></li>
                <li><a href="#" @click="showSub = !showSub">
                    <svg-vue icon="single-user" class="icon"/>
                    {{ this.$page.props.user.name }}</a>
                    <ul class="meta--sub-nav" v-if="showSub">
                        <li>
                            <Link :href="$$route('account')"><translate>Stammdaten</translate></Link>
                        </li>
                        <li>
                            <Link :href="$$route('addresses')"><translate>Adressen</translate></Link>
                        </li>
                    </ul>

                </li>
                <li>
                    <language-selector/>
                </li>
                <li>
                    <Link :href="$$route('logout')">
                        <svg-vue icon="lock-unlock" class="icon"/>
                        <translate>logout</translate>
                    </Link>
                </li>
            </ul>

            <ul v-if="!isClient">
                <li><a href="tel:+4922739537362">
                    <svg-vue icon="support-headphones" class="icon"/>
                    <translate>+ 49 (0) 2273 95 373 62</translate> </a></li>
                <li><a href="#" @click="showSub = !showSub">
                    <svg-vue icon="single-user" class="icon"/>
                    {{ this.$page.props.user.name }}</a>

                    <ul class="meta--sub-nav" v-if="showSub">
                        <li>
                            <Link :href="$$route('account')"><translate>Stammdaten</translate></Link>
                        </li>
                        <li>
                            <Link :href="$$route('abilities')"><translate>Fertigungskapazitäten und Prozesse</translate></Link>
                        </li>
                    </ul>
                </li>
                <li>
                    <language-selector/>
                </li>
                <li>
                    <Link :href="$$route('search')">
                        <svg-vue icon="search-1" class="icon"/>
                        <translate>Suche</translate>
                    </Link>
                </li>
                <li>
                    <Link :href="$$route('logout')">
                        <svg-vue icon="lock-unlock" class="icon"/>
                        <translate>logout</translate>
                    </Link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

import {Link} from '@inertiajs/vue3';
import LanguageSelector from '@partfactory/Shared/LanguageSelector';

export default {
    name: 'MetaAuthNav',
    components: {
        LanguageSelector,
        Link
    },
    data() {
        return {
            showSub: false,
        };
    },
    computed: {
        isClient() {
            return this.$page.props.routePrefix === 'client';
        },
    }
};
</script>
